module.exports = __webpack_public_path__ + "img/banner.e8b358ee.svg";